import React, { useContext } from 'react'
import { strCol, numCol, dollarCol } from '@integec/grid-tools/lib/cols'
// import { OaEventIoHeaders } from './../Headers'
import { rowHeaderRender } from 'core/utils'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'

const header = [
  strCol({
    ident: 'causeDescrip',
    display: 'Component Cause Group',
    isFiltered: true,
    width: 350,
  }),
  numCol({
    ident: 'lostOppMwh',
    display: 'Lost MWH',
    isFiltered: true,
    width: 150,
  }),

  dollarCol({
    ident: 'lostOppRevenue',
    display: 'Lost Revenue',
    isFiltered: true,
    width: 150,
  }),
  dollarCol({
    ident: 'lostOppMargin',
    display: 'Lost Margin',
    isFiltered: true,
    width: 150,
    sortOrder: 'desc',
  }),
  // numCol({ ident: 'total', display: 'Total' }),
]

const EventSummaryByCauseCode = props => {
  const { eventSummary = [] } = props
  const eventSummaryWithTotal = eventSummary.map(d => ({
    ...d,
    total:
      // parseFloat(d.lostOppMwh) +
      // parseFloat(d.lostOppRevenue) +
      parseFloat(d.lostOppMargin),
  }))
  return (
    <Grid
      data={eventSummaryWithTotal}
      headers={header}
      altBgColor="#ebebeb"
      render={virtualizedGridRenderer({
        // autoFixColByKey,
        rowHeaderRender,
        height: props.height || 300,
        width: props.width || 800,
        headerRowHeight: 30,
      })}
      selectionType="row"
      selectionMode="single"
      initialSortOptions={[
        dollarCol({
          ident: 'lostOppMargin',
          display: 'Lost Margin',
          isFiltered: true,
          width: 150,
          sortOrder: 'desc',
        }),
      ]}
      // sortOptions={header}
    />
  )
}

const EventSummaryByCauseCodeListDefault = props => {
  const { retrievedData } = useContext(MarginAnalysisContext)
  const { eventSummary = [] } = retrievedData
  return <EventSummaryByCauseCode {...props} eventSummary={eventSummary} />
}

export default EventSummaryByCauseCodeListDefault

export { EventSummaryByCauseCode }
